<div *ngIf="needsReload$ | async" class="app-update-banner">
  <span class="app-update-banner__message">{{ 'common.appUpdate.bannerMessage' | translate }}</span>
  <!-- Shown text; the announcement is the announcer's (the banner keeps no live region). -->
  <span *ngIf="heldBack" class="app-update-banner__held">{{ 'common.appUpdate.heldBack' | translate }}</span>
  <span class="app-update-banner__actions">
    <!-- A new build only (a chunk error cannot be put off: the page cannot load its code). -->
    <button
      *ngIf="canDismiss$ | async"
      type="button"
      class="app-update-banner__later"
      (click)="later()"
    >
      {{ 'common.appUpdate.laterButton' | translate }}
    </button>
    <button type="button" class="app-update-banner__button" (click)="reload()">
      {{ 'common.appUpdate.reloadButton' | translate }}
    </button>
  </span>
</div>

